<template>
    <div class="search-main">
        <div class="search-txt">{{ $t('wuliu.workbench.site') }}</div>
        <el-select class="site-select" popper-class="selectTree" v-model="siteId" :placeholder="$t('wuliu.workbench.selectSite')"
            @change="siteChange" clearable>
            <el-option v-for="item in siteArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
        </el-select>
        <div class="search-txt">{{ $t('wuliu.workbench.queryTime') }}</div>
        <el-date-picker class="search-input" popper-class="mydata" v-model="searchTime" size="small" type="daterange"
            align="right" value-format="yyyy-MM-dd" :unlink-panels="true" :range-separator="$t('wuliu.common.rangeSeparator')"
            :start-placeholder="$t('wuliu.common.startDate')" :end-placeholder="$t('wuliu.common.endDate')"
            :picker-options="pickerOptions" @change="searchDate($event)">
        </el-date-picker>
        <div class="search-btn">
            <div class="btn" v-for="item in searchTypeArr" :key="item.value"
                :class="Num === item.value ? 'btn-activity' : 'btn-default'" @click="searchBtn(item.value)">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        siteArr: {
            type: Array,
            default: () => [],
        },
        type: {
            type: String,
            default: '0',
        },
        changeSearch: {
            type: Function,
        },
        typeNum: {
            type: Number,
            default: 0,
        },
    },
    data () {
        return {
            siteId: '',
            Num: -1,
            searchTime: [],
            pickerOptions: {
                disabledDate (time) {
                    return time.getTime() > Date.now() - 8.64e6;
                },
            },
        };
    },
    computed: {
        searchTypeArr () {
            return [
                { name: this.$t('wuliu.workbench.last3Days'), value: 0 },
                { name: this.$t('wuliu.workbench.last30Days'), value: 3 },
                { name: this.$t('wuliu.workbench.thisWeek'), value: 1 },
                { name: this.$t('wuliu.workbench.thisMonth'), value: 2 },
                { name: this.$t('wuliu.workbench.thisYear'), value: 4 },
            ];
        },
    },
    mounted () { },
    watch: {
        searchTime: {
            handler (newVal) {
                if (!newVal) {
                    this.Num = -1;
                }
            },
            deep: true,
        },
        typeNum: {
            handler (newVal) {
                if (newVal === 2) {
                    this.searchBtn(newVal);
                } else {
                    this.Num = -1;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        siteChange (e) {
            this.siteId = e;
            console.log('siteId', this.siteId);

            this.setSearch();
        },
        searchDate (e) {
            console.log('searchDate', e);
            if (e) {
                this.searchTime = [`${e[0]} 00:00:00`, `${e[1]} 23:59:59`];
            } else {
                this.searchTime = ['', ''];
            }

            this.Num = -1;
            this.setSearch();
        },
        searchBtn (val) {
            this.Num = val;
            this.searchTime = this.HXtimeSlotChange(val);
            this.setSearch();
        },
        setSearch () {
            let obj = {
                beginTime: this.searchTime[0] || '',
                endTime: this.searchTime[1] || '',
                siteId: this.siteId,
            };
            this.$props.changeSearch(obj);
        },

        HXtimeSlotChange (val) {
            let startDate;
            let endDate;
            let timeForMat;
            let now = new Date(); // 当前日期
            let nowDayOfWeek = now.getDay(); // 今天本周的第几天
            let nowDay = now.getDate(); // 当前日
            let nowMonth = now.getMonth(); // 当前月
            let nowYear = now.getFullYear(); // 当前年

            // eslint-disable-next-line default-case
            switch (val) {
                case 0:
                    startDate = `${this.formatDate(new Date(nowYear, nowMonth, nowDay - 2))}`;
                    endDate = `${this.formatDate(new Date(nowYear, nowMonth, nowDay))}`;
                    break;
                case 1:
                    startDate = `${this.formatDate(new Date(nowYear, nowMonth, nowDay - nowDayOfWeek))}`;
                    endDate = `${this.formatDate(new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek)))}`;
                    break;
                case 2:
                    startDate = `${this.formatDate(new Date(nowYear, nowMonth, 1))}`;
                    endDate = `${this.formatDate(new Date(nowYear, nowMonth + 1, 0))}`;
                    break;
                case 3:
                    timeForMat = this.timeForMat(30);
                    startDate = timeForMat[0];
                    endDate = timeForMat[1];
                    break;
                case 4:
                    startDate = `${this.formatDate(new Date(nowYear, 0, 1))}`;
                    endDate = `${this.formatDate(new Date(nowYear, nowMonth, nowDay))}`;
                    break;
            }
            let s = val !== 3 ? `${startDate} 00:00:00` : startDate;
            let e = val !== 3 ? `${endDate} 23:59:59` : endDate;
            return [s, e];
        },
        formatDate (date) {
            let myyear = date.getFullYear();
            let mymonth = date.getMonth() + 1;
            let myweekday = date.getDate();
            if (mymonth < 10) {
                mymonth = `0${mymonth}`;
            }
            if (myweekday < 10) {
                myweekday = `0${myweekday}`;
            }
            return `${myyear}-${mymonth}-${myweekday}`;
        },
        timeForMat (count) {
            // 拼接时间
            const time1 = new Date();
            const time2 = new Date();
            time1.setTime(time1.getTime());

            const Y1 = time1.getFullYear();
            const M1 = time1.getMonth() + 1 > 9 ? time1.getMonth() + 1 : `0${time1.getMonth() + 1}`;
            const D1 = time1.getDate() > 9 ? time1.getDate() : `0${time1.getDate()}`;
            // eslint-disable-next-line no-useless-concat
            const timer1 = `${Y1}-${M1}-${D1} 23:59:59`; // 当前时间

            time2.setTime(time2.getTime() - 24 * 60 * 60 * 1000 * count);
            const Y2 = time2.getFullYear();
            const M2 = time2.getMonth() + 1 > 9 ? time2.getMonth() + 1 : `0${time2.getMonth() + 1}`;
            const D2 = time2.getDate() > 9 ? time2.getDate() : `0${time2.getDate()}`;
            // eslint-disable-next-line no-useless-concat
            const timer2 = `${Y2}-${M2}-${D2} 00:00:00`; // 之前的7天或者30天
            return [timer2, timer1];
        },
    },
};
</script>

<style lang="scss" scoped>
@use "sass:math";
$bg-main: #071150;
$bg-input: #112d7b;
$color-text: #ffffff;
$color-highlight: #49f0fd;
$border-color: rgba(73, 240, 253, 0.4);
$btn-height: 30px;
$input-height: 32px;
$spacing: 16px;

.search-main {
    display: flex;
    align-items: center;
    font-size: 14px;
    background: $bg-main;
    padding: 8px 0;

    .site-select {
        width: 160px;
        margin-right: $spacing;

        ::v-deep .el-input__inner {
            color: $color-text !important;
        }
    }
    ::v-deep {
        .el-input__inner,
        .el-range-editor--small .el-range-input,
        .el-cascader .el-input .el-input__inner {
            background-color: $bg-input;
            border-color: $bg-input;
            color: $color-text;
            height: $input-height;
            line-height: $input-height;
        }
        .el-date-editor .el-range-separator {
            color: $color-text;
            width: 30px;
            line-height: $input-height;
        }
        .el-range__icon {
            line-height: $input-height;
        }
        .el-cascader:not(.is-disabled):hover .el-input__inner,
        .el-cascader .el-input .el-input__inner:focus,
        .el-cascader .el-input.is-focus .el-input__inner {
            border-color: $border-color;
        }
    }
    .search-txt {
        line-height: $input-height;
        margin-right: $spacing;

        color: $color-text;
        white-space: nowrap;
    }
    .search-input {
        width: 280px;
        padding: 0 10px;
        margin-right: $spacing;
    }
    .search-btn {
        display: flex;
        .btn {
            width: 77px;
            height: $btn-height;
            line-height: $btn-height - 2;
            margin: 0 math.div($spacing, 2) 0 0;
            border-radius: 4px;
            text-align: center;
            cursor: pointer;
            transition: all 0.2s ease;
            border: 1px solid $border-color;
            &.btn-activity {
                background: linear-gradient(181deg, #1dc9ff 0%, #49f0fd 100%);
                color: #000;
            }
            &.btn-default {
                background: rgba(73, 240, 253, 0.2);
                color: $color-highlight;
                box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);

                &:hover {
                    background: rgba(73, 240, 253, 0.3); // 增加hover反馈
                }
            }
        }
    }
}
</style>
